import {
  SYNC_STYTCH_AUTH,
  SYNC_STYTCH_AUTH_SUCCESS,
  SYNC_STYTCH_AUTH_FAIL,
} from '../actions/types';

const INITIAL_STATE = {
  employee: null,
  organization: null,
  error: null,
  syncing: false,
};

export default function authReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SYNC_STYTCH_AUTH:
      return { ...state, syncing: true, error: null };
    case SYNC_STYTCH_AUTH_SUCCESS:
      return {
        ...state,
        syncing: false,
        employee: action.payload.employee,
        organization: action.payload.organization,
        error: null,
      };
    case SYNC_STYTCH_AUTH_FAIL:
      return {
        ...state,
        syncing: false,
        error: action.payload.error || 'Failed to sync with backend',
      };
    default:
      return state;
  }
}

